import React from 'react';
import FolderOpenRoundedIcon from '@mui/icons-material/FolderOpenRounded';
import TuneRoundedIcon from '@mui/icons-material/TuneRounded';

function BookmarkTabs({ 
  setSessionsDrawerOpen, 
  setPatternsDrawerOpen,
  sessionsDrawerOpen,
  patternsDrawerOpen
}) {
  
  const handleTabClick = (tab) => {
    if (tab === 'sessions') {
      setSessionsDrawerOpen(prev => !prev);
    } else if (tab === 'patterns') {
      setPatternsDrawerOpen(prev => !prev);
    }
  };

  return (
    <div className="bookmark-system">
      <div className="bookmark-tabs" role="tablist" aria-label="Panel toggles">
        <button
          className={`bookmark-tab ${sessionsDrawerOpen ? 'active' : ''}`}
          onClick={() => handleTabClick('sessions')}
          role="tab"
          aria-selected={sessionsDrawerOpen}
          aria-label={sessionsDrawerOpen ? 'Collapse sessions panel' : 'Expand sessions panel'}
          title={sessionsDrawerOpen ? 'Collapse sessions panel' : 'Expand sessions panel'}
        >
          <FolderOpenRoundedIcon aria-hidden="true" focusable="false" />
          <span>Documents</span>
        </button>
        <button
          className={`bookmark-tab ${patternsDrawerOpen ? 'active' : ''}`}
          onClick={() => handleTabClick('patterns')}
          role="tab"
          aria-selected={patternsDrawerOpen}
          aria-label={patternsDrawerOpen ? 'Collapse redaction patterns panel' : 'Expand redaction patterns panel'}
          title={patternsDrawerOpen ? 'Collapse redaction patterns panel' : 'Expand redaction patterns panel'}
        >
          <TuneRoundedIcon aria-hidden="true" focusable="false" />
          <span>Redaction patterns</span>
        </button>
      </div>
    </div>
  );
}

export default BookmarkTabs; 
